import { createContext, useContext } from "react";

import type { RiskManagementFilters } from "./types";

export const RiskManagementFiltersContext = createContext<
  RiskManagementFilters | undefined
>(undefined);

export const useRiskManagementFiltersContext = (): RiskManagementFilters => {
  const context = useContext(RiskManagementFiltersContext);

  if (!context) {
    throw new Error(
      "useRiskManagementFiltersContext must be used within a RiskManagementFiltersProvider",
    );
  }

  return context;
};
